export default function StatTile({ icon: Icon, label, value, tone = "surface-neutral", testId }) {
  return (
    <article className={`neo-card ${tone} p-4`} data-testid={testId}>
      <div className="flex items-start justify-between gap-4">
        <div>
          <p className="text-xs font-black uppercase text-slate-500" data-testid={`${testId}-label`}>{label}</p>
          <p className="mt-2 font-display text-3xl font-black" data-testid={`${testId}-value`}>{value}</p>
        </div>
        <span className="rounded-[8px] border-2 border-slate-950 bg-white p-2" data-testid={`${testId}-icon`}>
          <Icon size={22} strokeWidth={2.6} />
        </span>
      </div>
    </article>
  );
}